module.exports = __webpack_public_path__ + "static/media/37-8.4d959967.mp3";